import * as React from "react";
import { IconProps } from "./IconProps";

export const IconArrowUpBlock = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M4.39998 9.5C4.25997 9.5 4.18996 9.5 4.13648 9.47275C4.08944 9.44878 4.0512 9.41054 4.02723 9.3635C3.99998 9.31002 3.99998 9.24001 3.99998 9.1L4 5.57143H2.5L5.99998 1.5L9.5 5.57143H8L7.99998 9.1C7.99998 9.24001 7.99998 9.31002 7.97273 9.3635C7.94877 9.41054 7.91052 9.44878 7.86348 9.47275C7.81 9.5 7.74 9.5 7.59998 9.5H4.39998Z"
          fill={color}
        />
        <path
          d="M4.39971 9.5C4.2597 9.5 4.18969 9.5 4.13621 9.47275C4.08917 9.44878 4.05093 9.41054 4.02696 9.3635C3.99971 9.31002 3.99971 9.24001 3.99971 9.1V5.57143H2.14258L5.99971 1.5L9.85686 5.57143H7.99971V9.1C7.99971 9.24001 7.99971 9.31002 7.97246 9.3635C7.9485 9.41054 7.91025 9.44878 7.86321 9.47275C7.80973 9.5 7.73973 9.5 7.59971 9.5H4.39971Z"
          stroke="#4E677E"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
